export class GanttDateModel {
  date: Date;
  showSignpost: boolean;

  constructor(init?: Partial<GanttDateModel>) {
    Object.assign(this, init);
  }
}
